export const CONFIG_UPDATE = 'CONFIG_UPDATE';
